import { useIonModal } from '@ionic/react'

import { ButtonRoundSm } from '@apps-common/components/elements/button'
import { MyMonitoringFilterModal } from '@apps-common/components/modals/MyMonitoringFilterModal'
import { DEFAULT_ACTION_BUTTON_COLOR_CLASSES } from '@apps-common/config/colors'
import { commonIcons } from '@apps-common/config/icons'
import { MODAL_NO_BLUR } from '@apps-common/config/modal'
import { useFilterModalAnimation } from '@apps-common/hooks/useFilterModalAnimation'

export const MyMonitoringFilterButton: React.FC = () => {
  const animations = useFilterModalAnimation({ desktopCss: MODAL_NO_BLUR.cssClass })

  const [present, dismiss] = useIonModal(MyMonitoringFilterModal, {
    componentProps: {},
    onDismiss: (data: string, role: string) => {
      dismiss(data, role)
    },
    enableBackdropDismiss: true
  })

  return (
    <ButtonRoundSm
      type='button'
      size='lg'
      className={DEFAULT_ACTION_BUTTON_COLOR_CLASSES}
      callback={() =>
        present({
          cssClass: animations.css,
          ...animations
        })
      }
    >
      <commonIcons.filter />
    </ButtonRoundSm>
  )
}
